import React from "react";
import { Draggable } from '@hello-pangea/dnd';
import { Typography, theme } from 'antd';

import TasksList from './TasksList';
import { useTaskSelection } from './TaskSelectionContext';

import type { Task } from '../../types';
import type { DraggableStyle } from '@hello-pangea/dnd';

const { Text } = Typography;

interface ColumnProps {
    title: string;
    columnId: number;
    tasks: Task[];
    index: number;
    todoId: number;
}

/** Колонки двигаются только по горизонтали — иначе уезжает вертикальный скролл соседних списков */
const lockColumnDragToX = (style?: DraggableStyle): DraggableStyle | undefined => {
    if (!style?.transform) {
        return style;
    }

    const nextTransform = style.transform
        .replace(/translate\(([^,]+),\s*[^)]+\)/, 'translate($1, 0px)')
        .replace(/translate3d\(([^,]+),\s*[^,]+,\s*([^)]+)\)/, 'translate3d($1, 0px, $2)');

    return {
        ...style,
        transform: nextTransform,
    };
};

const Column = (props: ColumnProps) => {
    const { title, columnId, todoId, tasks, index } = props;
    const { token } = theme.useToken();
    const { selectMany, deselectMany, selectedIds } = useTaskSelection();

    const handleHeaderDoubleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        const columnTaskIds = tasks.map((task) => Number(task.taskId));
        const hasSelectedInColumn = columnTaskIds.some((id) => selectedIds.includes(id));
        if (hasSelectedInColumn) {
            deselectMany(columnTaskIds);
            return;
        }
        selectMany(columnTaskIds);
    };

    return (
        <Draggable draggableId={columnId.toString()} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className="column"
                    style={lockColumnDragToX(provided.draggableProps.style)}
                >
                    <div
                        className="column-header"
                        {...provided.dragHandleProps}
                        onDoubleClick={handleHeaderDoubleClick}
                    >
                        <Text strong style={{ margin: 0, color: token.colorText }}>
                            {title}
                        </Text>
                        <span
                            className="column-header__count"
                            style={{
                                color: token.colorText,
                                background: token.colorFillSecondary,
                                border: `1px solid ${token.colorBorderSecondary}`,
                            }}
                        >
                            {tasks.length}
                        </span>
                    </div>
                    <TasksList
                        columnId={columnId}
                        tasks={tasks}
                        todoId={todoId}
                    />
                </div>
            )}
        </Draggable>
    );
};

export default Column;
